<template>
  <Layout>
    <!-- <Appdowload></Appdowload> -->
    <div class="bordertop3" v-if="!show_ie" ref="main">
      <div class="header">
        <HeaderNav name="2"></HeaderNav>
      </div>
      <div class="train-detail">
        <div class="head container-padding">
          <div class="bread">
            <p>
              <router-link :to="{path:'/train/index'}">瑜伽培训</router-link>
              &nbsp;&nbsp;\&nbsp;&nbsp;{{baseInfo.train_name}}
            </p>
          </div>
          <div class="head-detail">
            <div class="img flt">
              <img
                v-if="baseInfo.image_url==undefined || baseInfo.image_url.length<=0"
                src="https://file.jkxuetang.com/khyoga/banner.jpg"
              />
              <el-carousel width="380px;" height="380px" v-else>
                <el-carousel-item v-for="item in baseInfo.image_url" :key="item">
                  <img :src="item" style="width: 380px;height:380px"  />
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="info flt">
              <h1>{{baseInfo.train_name}}</h1>
              <div class="jieshao" v-html="baseInfo.train_introduction"></div>
              <div class="price-div">
                <p>
                  <!-- 原价: -->
                  <!-- <span class="price-span">￥{{baseInfo.sku ? baseInfo.sku[sku_key].price : ''}}</span> -->
                  <span class="price-span">{{baseInfo.price || ''}}</span>
                  <!-- <span class="deadline">截止报名日期:{{baseInfo.reg_end_time}}</span> -->
                </p>
              </div>
              <div class="skus">
                <div
                  v-for="(sku_item,sku_item_key) in baseInfo.sku" :key="sku_item_key" v-if="sku_item.status == '1'"
                  @click="changeSkuKey(sku_item_key)"
                  class="sku-item "
                  :class="{active:sku_item_key==sku_key}"
                >
                {{sku_item.type_name}}</div>
              </div>
              <div>
                <el-button type="danger" @click="zixun" class="zixun_button" round>咨询</el-button>
                <!--<a href="javascript:;" @click="zixun" class="btn-advisory">咨询</a>-->
              </div>
            </div>
          </div>
        </div>
        <div class="train-body container-padding">
          <div :style="{width:baseInfo.left_width}" class="flt train-body-left">
            <div class="head" v-if="trainPromotionInfo.length!=0">
              <div class>
                <h1>特惠活动</h1>
              </div>
              <div class="activity-content">
                <!-- <p
                  v-for="(promotionInfo,promotionInfo_key) in trainPromotionInfo"
                >{{promotionInfo_key+1}}.&nbsp;&nbsp;{{promotionInfo.content}}</p>-->
                <p v-for="(promotionInfo,promotionInfo_key) in trainPromotionInfo" :key="promotionInfo_key">{{promotionInfo}}</p>
              </div>
            </div>
            <div :class="trainPromotionInfo.length==0?'detail_two':'detail'">
              <div class>
                <h1>详情</h1>
              </div>
              <div v-html="baseInfo.detail" class="course-content"></div>
            </div>
          </div>
          <div v-if="baseInfo.has_teacher==1" class="flt train-body-right">
            <div class="title">
              <h1>教师介绍</h1>
            </div>
            <div v-for="(t,teacher_key) in teacher" :key="teacher_key">
              <div class="avatar">
                <img
                  :src="'http://'+t.avatar"
                  v-if="t.avatar!=''"
                />
                <img src="http://www.khyoga.net/upload/image/20200721/69ae0a70c4d40f0a38f0487d11d8187c.jpg" v-else>
                <h1>{{t.teacher_name}}</h1>
                <div v-for="(l,l_index) in t.teach_level" :key="l_index">
                  <h2>{{l}}</h2>
                </div>
                <!-- <h2>{{t.teach_level_string}}</h2> -->
              </div>
              <div class="experience">
                <h1>教师简介</h1>
                <p>{{t.teacher_introduction}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterDes v-if="!show_ie"></FooterDes>
    <HintIE v-if="show_ie"></HintIE>
  </Layout>
</template>

<script>
import { getData, set_cache_item } from "../../../static/js/util.js";
import config from "../../../static/js/myconfig";
import headernav from "../../components/HeaderNav";
import footer from "../../components/FooterDes";
import Appdowload from "../../components/Appdowload";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import HintIE from "../../components/HintIE";
export default {
  components: {
    HeaderNav: headernav,
    FooterDes: footer,
    Appdowload: Appdowload,
    HintIE: HintIE
  },
  data() {
    return {
      id: 0,
      baseInfo: {},
      trainFrontTrainInfo: {},
      trainPromotionInfo: [],
      sku_key: 0,
      teacher: {},
      show_ie: false
    };
  },
  methods: {
    isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window)
        this.show_ie = true; //不支付IE
    },
    zixun: function() {
      this.$alert("更多内容请扫描下载APP体验", "", {
        confirmButtonText: "确定",
        showClose: false
      });
    },
    changeSkuKey: function(sku_key) {
      this.sku_key = sku_key;
    },
    getTrainBaseInfo: function() {
      var that = this;
      getData(config.apimethod.getTrainBaseInfo + "?id=" + that.id, function(
        res
      ) {
        var data = res.data;
        data.has_teacher = 1;
        data.left_width = "";
        if (data.teacher == undefined || data.teacher.length <= 0) {
          data.has_teacher = 0;
          data.left_width = "100%";
        } else {
          that.teacher = data.teacher;
          that.teacher.teach_level_string = "";
          for (var i = 0; i < that.teacher.length; i++) {
            that.teacher.teach_level_string += data.teacher[i].teach_level[i];
          }
        }
        // console.info("data",data)
        that.baseInfo = data;
      });
    },
    getTrainFrontTrainInfo: function() {
      var that = this;
      getData(
        config.apimethod.getTrainFrontTrainInfo + "?id=" + that.id,
        function(res) {
          var data = res.data;
          that.trainFrontTrainInfo = data;
        }
      );
    },
    getTrainPromotionInfo: function() {
      var that = this;
      getData(
        config.apimethod.getTrainPromotionInfo + "?id=" + that.id,
        function(res) {
          var data = res.data.promotion;
          console.info("data", data);
          that.trainPromotionInfo = data;
        }
      );
    }
  },
  mounted() {
    window.scrollTo(0,0)
    this.id = this.$route.query.id;
    this.getTrainBaseInfo();
    // this.getTrainFrontTrainInfo();
    this.getTrainPromotionInfo();
    this.isIE();
  }
};
</script>

<style>
.indexnews .newslist {
  border: none;
  padding: 0 16px;
}
.indexnews .ivu-card-body {
  padding: 0;
}
.abstit {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/train/detail.vue